import { IconButton, Tooltip } from '@mui/material';
import { ReactNode } from 'react';

export interface ToolbarButtonProps {
  label: string;
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

export const ToolbarButton = ({ label, icon, onClick, disabled }: ToolbarButtonProps) => (
  <Tooltip title={label}>
    <span>
      <IconButton size="small" aria-label={label} disabled={disabled} onClick={onClick}>
        {icon}
      </IconButton>
    </span>
  </Tooltip>
);
